export default function ExpandButton({ isExpanded, onToggle }) {
  return (
    <button
      onClick={onToggle}
      className="text-emerald-300 text-xs hover:text-emerald-200 transition-colors flex items-center gap-1 bg-gray-800/80 px-2 py-1 rounded"
    >
      {isExpanded ? 'See less' : 'See more'}
      <span className={`transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}>
        ▼
      </span>
    </button>
  );
}